export default __webpack_public_path__ + "static/media/011-free wifi.8b07cd7d.svg";